import React, { useEffect } from 'react'

import PropTypes from 'prop-types'
import { driver } from 'driver.js'
import clsx from 'clsx'

import useStyles from 'components/DriveTour/styles'

const GuestDriveTour = ({ stepsMatrix, customStyle, open, setOpen }) => {
  const classes = useStyles()

  useEffect(() => {
    if (!open) return

    const tourDriver = driver({
      showProgress: true,
      popoverClass: clsx(classes.defaultPopover, customStyle),
      steps: stepsMatrix,
      progressText: '{{current}} de {{total}}',
      stagePadding: 4,
      stageRadius: 4,
      disableActiveInteraction: true,
      prevBtnText: 'Anterior',
      nextBtnText: 'Próximo',
      doneBtnText: 'Concluir',
      onDestroyStarted: () => {
        setOpen(false)
        tourDriver.destroy()
      },
    })

    tourDriver.drive()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open])

  return <></>
}

GuestDriveTour.propTypes = {
  stepsMatrix: PropTypes.arrayOf(PropTypes.object),
  customStyle: PropTypes.string,
  open: PropTypes.bool,
  setOpen: PropTypes.func,
}

export default GuestDriveTour
